// Generated by scripts/explanations/build.mjs --emit.
export const EXPLANATION_ROOT = '/explanations/ja-v1-0569b6c6f842';
//# sourceMappingURL=explanation-config.js.map